import SET_SELLER from './types';
export default {
  [SET_SELLER](state, payload) {
    var currentState = state;
    currentState.seller = payload;
  }
};